import { Link } from 'react-router-dom';
import { ScoreInfoDialog, AboutSystemDialog } from '@/components/ScoreInfoDialogs';
import { AIAnalysisExplainerDialog } from '@/components/AIAnalysisExplainerDialog';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-8 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-bold text-lg mb-2">System Developer</h4>
            <p className="text-slate-300">Dr. Ivan Inkov</p>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-2">Ownership</h4>
            <p className="text-slate-300 font-semibold">International Sci Ink Press Ltd.</p>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-2">Quick Links</h4>
            <div className="space-y-2">
              <ScoreInfoDialog />
              <AIAnalysisExplainerDialog />
              <div>
                <Link to="/explorer" className="text-slate-300 hover:text-white block">
                  Explorer
                </Link>
              </div>
              <div>
                <a href="/api/seo/authors" className="text-slate-300 hover:text-white block">
                  Authors Directory
                </a>
              </div>
              <div>
                <Link to="/compare" className="text-slate-300 hover:text-white block">
                  Compare Articles
                </Link>
              </div>
              <div>
                <Link to="/contact" className="text-slate-300 hover:text-white block">
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-6 pt-6 text-center text-slate-400 text-sm">
          <p>© {new Date().getFullYear()} International Sci Ink Press Ltd. All rights reserved.</p>
          <p className="mt-2">Evidentica v1.0</p>
        </div>
      </div>
    </footer>
  );
};
